import { sha256 } from 'hash.js';

/**
 * hashes a string
 *
 * @param {string} value
 * @returns {string} 10 digit hash
 */
export function hash(value: string): string {
  if (value === undefined || value === null) {
    return value;
  }

  return sha256().update(value).digest('hex').substr(0, 10);
}
